// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteFeedItemBar_container__2a56x","buttonContainer":"DeleteFeedItemBar_buttonContainer__13LRL","button":"DeleteFeedItemBar_button__54yly"};